<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col md="6" sm="12">

          <b-form-group label-size='lg' label-class='addgrouplabel' label='Group Name' label-for='groupName' :horizontal='false'>
            <b-form-input @blur="validateGroupName" data-vv-name="group.groupName"
            v-validate="'required|max:255|uniqueGroupName'" data-vv-as="Group Name" size="lg" id='groupName' v-model='group.groupName'></b-form-input>
            <span v-show="inputValidationErrors.has('group.groupName')" class="text-info">{{ inputValidationErrors.first('group.groupName') }}</span>
            <span v-show="groupNameError" class="text-info"> Group Name already exist. Please enter different name! </span>
          </b-form-group>


          <b-form-group label-size='lg' label-class='addgrouplabel' label='Is Owning Group' label-for='isOwningGroup' :horizontal='false'>
            <b-form-select size="lg"
            data-vv-name="group.isOwningGroup"
            v-validate="'required'"
            data-vv-as="Is Owning Group"
            :options="isOwningGroupOptions"
            id='isOwningGroup'
            v-model='group.isOwningGroup'>
            </b-form-select>
            <span v-show="inputValidationErrors.has('group.isOwningGroup')" class="text-info">{{ inputValidationErrors.first('group.isOwningGroup') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='addgrouplabel' label='State' label-for='defaultOrg' :horizontal='false'>
            <b-form-select size="lg"
              :options="stateAndAbbrev"
              v-validate="'required'"
              v-model="stateName"
            />
            <span v-show="inputValidationErrors.has('stateName')" class="text-info">{{ inputValidationErrors.first('stateName') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='addgrouplabel' label='Default Organization' label-for='defaultOrg' :horizontal='false'>
            <b-form-select size="lg"
              :options="defaultOrganizationOptions(organizations)"
              v-validate="'required'"
              v-model="group.defaultOrg"
              @change="handleChange"
              />
              <span v-show="inputValidationErrors.has('group.defaultOrg')" class="text-info">{{ inputValidationErrors.first('group.defaultOrg') }}</span>
          </b-form-group>

            <!-- <b-form-group v-else label-size='lg' label-class='addgrouplabel' label='Default Organization' label-for='defaultOrgName' :horizontal='false'>
            <b-form-input data-vv-name="group.defaultOrgName" v-validate="'required|max:255|uniqueOrgName'" data-vv-as="Default Organization Name" size="lg" id='groupName' v-model='group.defaultOrgName'></b-form-input>
            <span v-show="inputValidationErrors.has('group.defaultOrgName')" class="text-info">{{ inputValidationErrors.first('group.defaultOrgName') }}</span>
          </b-form-group> -->

        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'

export default {
  name: 'create-group-form',
  props: {
    group: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Treeselect },
  computed: {
    ...mapGetters({
      organizations: 'getAllOrganizations',
      isOwningGroupOptions: 'getIsOwningGroupOptions',
      stateAndAbbrev: 'getStateAndAbbrev'
    })
  },
  inject: ['$validator'],
  data: function () {
    return {
      tabIndex: 0,
      groupNameError: false,
      stateName: ''
    }
  },
  created: function () {
    const defaultOrg = this.group.defaultOrg
    if (defaultOrg) {
      this.stateName = defaultOrg.mailingStateAbbreviation
      this.group.defaultOrg = defaultOrg.id
    } else {
      this.stateName = this.stateAndAbbrev[0].value
    }
    this.searchOrganizations()
    this.$validator.extend('uniqueGroupName', {
      getMessage: field => 'Group name already exist. Please enter different name',
      validate: (value) => {
        return this.validateGroupName()
      }
    })
  },
  methods: {
    defaultOrganizationOptions (organizations) {
      return _.sortBy(organizations, 'title')
        .filter((org) => {
          if (!this.stateName) return true
          return org.mailingStateAbbreviation === this.stateName
        })
        .map((org) => {
          return { value: org.id, text: org.title }
        })
    },
    searchOrganizations () {
      this.$store.dispatch('getOrganizations', {})
    },
    validateGroupName () {
      return this.$store.dispatch('validateGroupName', _.trim(this.group.groupName)).then((response) => {
        return !(response.length > 0 && response.map((x) => x.id).indexOf(this.group.id) === -1)
      })
    },
    handleChange () {
      const organizations = this.$store.getters.getAllOrganizations
      const defaultOrganization = organizations.filter(org => org.id === this.group.defaultOrg)[0]
      this.group.defaultOrgName = defaultOrganization ? defaultOrganization.title : ''
    }
  }
}
</script>

<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/t1/Admin/GroupForm.vue